<svg [attr.height]="height" [attr.width]="width" fill="none" viewBox="4 -7 11 33" xmlns="http://www.w3.org/2000/svg">
    <g>
        @if (hasWarning) {
            <circle cx="9.5" cy="9.5" fill="url('#myGradient')" r="15"/>
        }
        <circle [attr.fill]="innerColor" cx="9.5" cy="9.5" r="9.5"/>
        <circle [attr.stroke]="outerColor" cx="9.5" cy="9.5" r="8" stroke-width="3"/>
    </g>
    <defs>
        <radialGradient id="myGradient">
            <stop offset="60%" stop-color="#F76B1B" stop-opacity="1"/>
            <stop offset="100%" stop-color="#FF690F" stop-opacity="0.1"/>
        </radialGradient>
        <filter color-interpolation-filters="sRGB"
                filterUnits="userSpaceOnUse"
                height="50"
                id="filter0_d_538_20485"
                width="50"
                x="0"
                y="0">
            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
            <feColorMatrix in="SourceAlpha"
                           result="hardAlpha"
                           type="matrix"
                           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
            <feOffset dy="1"/>
            <feGaussianBlur stdDeviation="1"/>
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
            <feBlend in2="BackgroundImageFix" mode="normal" result="effect1_dropShadow_538_20485"/>
            <feBlend in="SourceGraphic" in2="effect1_dropShadow_538_20485" mode="normal" result="shape"/>
        </filter>
    </defs>
</svg>
